export default "__VITE_PUBLIC_ASSET__f26420bd__"